import React, { Component } from 'react';
import { Popover, Col, Modal, Icon, Button, Checkbox, Radio, Transfer, Select, Row, Input, Tag } from 'antd';
import SvgIcon from 'SvgIcon';
import * as filterredux from '../../redux/filterscheme';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as BasicComponents from '../basic';
import FilterDefined from './filterDefined'
import _ from 'lodash'
import { proxy } from '../../helpers/util';
let BasicComponentsMap = {}, Solutionitem = {},  id = null;
let Sortable = null;
if (process.env.__CLIENT__) Sortable = require('react-sortablejs');
for (var attr in BasicComponents)
  BasicComponentsMap[attr.toLocaleLowerCase()] = BasicComponents[attr];
class FilterScheme extends Component {
  constructor(props) {
    super(props);
    let User = cb.rest.AppContext.user && cb.rest.AppContext.user.authCodes || []
    let userType = cb.rest.AppContext.user && cb.rest.AppContext.user.userType
    let datasource = this.props.model.getParams().hasDataSource
    this.viewModel = new cb.models.ContainerModel({ params: { cardKey: props.cardKey } });
    this.state = {
      mention: false,
      definedVisible: false,
      inMouseitemName: "",
      checked: [],
      IsdefaultValue: 0,
      inpValue: '',
      NewList: "",
      sort: "",
      filterId: this.props.filterId,
      modelId: this.props.Id,
      ValueList: [],
      InputValue: "",
      visible: false,
      id: null,
      NewaddChecked: [],
      checkedValue: [],
      copy_checkedValue: [],
      showDele: true,
      checkedValue2: [],
      queryCheckValue: [],
      User: User,
      userType: userType,
      datasource: datasource,
      startEnter: false,
      saveSort: [],
      enterArry: [],
      dateEmunMap: {},
      mustArry:[],
      planValue:1,
      solutionId:0
    };
    this.getEnum();
    this.commonVOs = [];
    this.commonitem = {};
    this.commonNewitem = {};
  }
  async getEnum() {
    const config = {
      url: 'enum/getEnumStrFetch',
      method: 'GET',
      params: {
        enumtype: 'pb_dateinterval'
      }
    };
    const json = await proxy(config);
    if (json.code !== 200) {
      cb.utils.alert('获取枚举失败' + json.message, 'error');
      return;
    }
    this.enumArr = json.data ? JSON.parse(json.data) : null;
  }
  componentDidMount() {
    this.props.filterredux.init(this.state.modelId);
    this.props.filterredux.getSchemeListData(this.state.modelId, this.state.filterId);
    this.props.filterredux.getQueryItem(this.state.modelId, this.state.filterId);
    this.props.filterredux.getCompareLogic(this.state.modelId);
  }
  handleBodyClick = (e) => {
    if (e.target.className == "query-item-button add-query-criteria") {
      if (e.stopPropagation) {
        e.stopPropagation();
      }
    }
    document.body.removeEventListener('click', this.handleBodyClick);
  }
  render() {
    if (this.props.filterscheme[this.state.modelId] == undefined) return null
    let type = this.state.visible ? "up" : "down";
    let button = <div style={{ width: "20px", height: "30px" }}> <Icon type={type} /> </div>;
    let schemeList = this.getSchemeListRender();
    let addScheme = this.AddSchemeRender();
    let schemePop = (
      <div >
        <div style={{ marginLeft: 0, clear: 'both', whiteSpace: 'nowrap' }} className="scheme-popover">
          <Popover placement="bottomLeft" overlayStyle={{ width: "236px" }} content={schemeList} trigger={"click"} visible={this.state.visible} onVisibleChange={this.handleVisibleChange.bind(this)} getPopupContainer={triggerNode => triggerNode.parentElement.parentElement}>
          <div className="filter-scheme Grouping-condition">
              <div className="filter-scheme-input Grouping-condition-input" >
                <span className="filter-scheme-span " style={{ cursor: "pointer" }} >{this.props.filterscheme[this.state.modelId].currentName}</span>
                {button}
              </div>
            </div>
          </Popover>
        </div>
      </div>
    );
    return (<div className="scheme-list">{schemePop}{addScheme}</div>);
  }
  handleVisibleChange() {
    this.setState({ visible: !this.state.visible, definedVisible: false, checkedValue2: [], checkedValue: [], ValueList: [] });
  }
  //方案列表
  getSchemeListRender() {
    let schemeList = this.props.filterscheme[this.state.modelId].schemeList;
    let currentId = this.props.filterscheme[this.state.modelId].currentId;
    let showDele = this.state.showDele;
    let { User, userType, datasource } = this.state
    let renderList = [];
    let filteradd = null;
    let personalPlan = [];
    let publicPlan = [];
    if (schemeList && schemeList.length > 0) {
      schemeList.forEach(function (element, index) {
        if(element.isPublic){
        let item;
        let isChecked = element.id == currentId ? true : false;
        let itemChecked = isChecked ? <span className="groupCondition-Checked" ><i className="anticon icon-xuanzhong1" checked={isChecked}></i>  </span > : <span className="groupCondition-Checked" ></span >;
        let isDefault = element.isDefault ? element.isDefault : false;
        let itemDefault = isDefault ? <span className="groupCondition-Default"> <span className="crossdefault-btn">默认</span>  </span> : <span className="groupCondition-Default"></span>;
        let isMouseEnter = element.isMouseEnter ? element.isMouseEnter : false;
        let editScheme = (User.indexOf("userdef_schemaSetting") > -1 || userType == 0) ? <span onClick={() => this.editSchemeInfo(element.id,element.isPublic)}>设置</span> : <span></span>;
        let deleteScheme = (User.indexOf("userdef_schemaSetting") > -1 || userType == 0) ? <span className="Noclose" onClick={() => this.deleteScheme(element.id, this.state.filterId)} style={{ display: showDele == true ? 'inline' : 'none' }}>删除</span> : <span></span>
        let itemEnter = isMouseEnter && (User.indexOf("userdef_schemaSetting") > -1 || userType == 0) ?
          <span className="groupCondition-MouseEnter">{isDefault ? null : <span className="stopclose" onClick={(e) => this.setDefaultScheme(element.id, e,true)}>设为默认</span>}
            {editScheme}
            {deleteScheme}
          </span> : <span className="groupCondition-MouseEnter"></span  >;
        item = (<Row key={index} style={{ minHeight: "25px" }} onMouseEnter={(e) => this.IsEnterSchemeitem(true, e, element.id)} onMouseLeave={(e) => this.IsEnterSchemeitem(false, e, element.id)}>
          {itemChecked}
          <span style={{ cursor: "pointer" }} onClick={() => this.chooseScheme(element.id)}> {element.solutionName ? element.solutionName : element.id}</span>
          {itemDefault}
          {itemEnter}
        </Row>
        )
        publicPlan.push(item);
        }
        else{
        let isChecked = element.id == currentId ? true : false;
        let itemChecked = isChecked ? <span className="groupCondition-Checked" ><i className="anticon icon-xuanzhong1" checked={isChecked}></i>  </span > : <span className="groupCondition-Checked" ></span >;

        let isDefault = element.isDefault ? element.isDefault : 0;
        let itemDefault = isDefault ? <span className="groupCondition-Default"> <span className="crossdefault-btn">默认</span>  </span> : <span className="groupCondition-Default"></span>;
        let isMouseEnter = element.isMouseEnter ? element.isMouseEnter : false;
        let editScheme =<span onClick={() => this.editSchemeInfo(element.id,element.isPublic)}>设置</span> ;
        let deleteScheme = <span className="Noclose" onClick={() => this.deleteScheme(element.id, this.state.filterId)}>删除</span>;
        let itemEnter = isMouseEnter ?
          <span className="groupCondition-MouseEnter">{isDefault ? null : <span className="stopclose" onClick={(e) => this.setDefaultScheme(element.id, e,false)}>设为默认</span>}
            {editScheme}
            {deleteScheme}
          </span> : <span className="groupCondition-MouseEnter"></span  >;
        let perItem = (<Row key={index} style={{ minHeight: "25px" }} onMouseEnter={(e) => this.IsEnterSchemeitem(true, e, element.id)} onMouseLeave={(e) => this.IsEnterSchemeitem(false, e, element.id)}>
          {itemChecked}
          <span style={{ cursor: "pointer" }} onClick={() => this.chooseScheme(element.id)}> {element.solutionName ? element.solutionName : element.id}</span>
          {itemDefault}
          {itemEnter}
        </Row>
        )
        personalPlan.push(perItem);
        }
      }, this);
    }
    if ((User.indexOf("userdef_filter") > -1) && datasource) {
      filteradd = <div className="defined_button" onClick={() => this.openDefined()}><SvgIcon type="zidingyitiaozheng" />自定义过滤条件</div>
    }
    else {
      if (userType == 0 && datasource) {
        filteradd = <div className="defined_button" onClick={() => this.openDefined()}><SvgIcon type="zidingyitiaozheng" />自定义过滤条件</div>
      }
      else { filteradd = null; }
    }
    let addScheme =   <div className="add-scheme-button" onClick={() => this.AddScheme()} style={{ cursor: "pointer" }}><SvgIcon type="plus" />新增方案</div>;
    let schemeClass = User.indexOf("userdef_schemaSetting") > -1 ? "" : "haveno_addScheme";
    let addSchemeClass = User.indexOf("userdef_schemaSetting") > -1 ? "" : "haveno_addIcon";
    // let planClass = personalPlan.length > 0 ? "add-personal-plan" : ""
    return (
      <div className={"scheme-List group-add-grouping-count defined-filterItem " + schemeClass} style={{ paddingBottom: 60 }}>
        <div className={"scheme-List-content  add-personal-plan"}>
          <div className="public_plan">
            <div className="public_plan_name">公共方案</div>
          <div className="public_plan_content">{publicPlan}</div>
          </div>
          <div className={personalPlan.length > 0 ? "show_perPlan":"hide_perPlan"}>
            <div className="public_plan_name">个人方案</div>
          <div className="public_plan_content">{personalPlan}</div>
          </div>
          </div>
        <div className={"add-scheme group-add-grouping " + addSchemeClass} style={{ height: 76 }}>
          {addScheme}
          {filteradd}
        </div>
      </div>
    );
  }
  openDefined() {
    this.handleVisibleChange()
    this.setState({ definedVisible: true })
  }
  IsEnterSchemeitem(bEnter, e, id) {
    let self = this;
    this.props.filterredux.IsEnterSchemeitem(bEnter, id, this.state.modelId);
    let schemeList = this.props.filterscheme[this.state.modelId].schemeList;
    if (schemeList && schemeList.length > 0) {
      schemeList.forEach(function (ele, index) {
        let isDefault = ele.isDefault;
        if (id == ele.id) {
          if (isDefault) { self.setState({ showDele: false }) }
          else { self.setState({ showDele: true }) }
        }
      })
    }
  }
  //默认
  setDefaultScheme(defaultid, e,isPublic) {
    e.nativeEvent.stopImmediatePropagation();
    e.nativeEvent.stopPropagation();
    this.props.filterredux.setDefaultScheme(defaultid, this.state.filterId, this.state.modelId, this.props.schemeListChange,isPublic);
  }
  triggerReferBrowse(referModel) {
    if (!referModel) return;
    var referValue = referModel.getValue();
    if (!referValue) return;
    referModel.browse(false, function (vm) {
      vm.on('getRefMetaReady', function () {
        var condition = {
          'isExtend': true,
          simpleVOs: [{ field: referModel.getState('valueField'), op: 'in', value1: referValue.split(',') }]
        };
        vm.execute('pressEnter', { model: referModel, condition: condition, browse: false });
      });
    });
  }
  //设置
  editSchemeInfo(id,isPublic) {
    this.setState({ visible: !this.state.visible, mention: false,solutionId:id })
    this.props.filterredux.AddScheme(!this.props.filterscheme[this.state.modelId].bAddscheme, this.state.modelId);
    if (!this.props.filterscheme[this.state.modelId].bEdit) { this.props.filterredux.Isedit(!this.props.filterscheme[this.state.modelId].bEdit, this.state.modelId); }
    if (this.props.filterscheme[this.state.modelId].isdefault) { this.props.filterredux.IsDefault(!this.props.filterscheme[this.state.modelId].isdefault, this.state.modelId); }
    if (this.props.filterscheme[this.state.modelId].queryVisible) { this.props.filterredux.openQuerylist(false, this.state.modelId); }
    this.props.filterredux.editSchemeInfo(id,isPublic, (editSchemeitem) => {
      let AllFilterModel = editSchemeitem.AllFilterModel;
      let queryCheckValue = editSchemeitem.CommonModel;
      let InputValue = editSchemeitem.solutionName;
      let IsdefaultValue = editSchemeitem.isDefault;
      let ID = editSchemeitem.id
      if (IsdefaultValue) { this.props.filterredux.IsDefault(true, this.state.modelId); }
      queryCheckValue.forEach((element) => {
        let _index = _.findIndex(AllFilterModel, (obj) => {
          return obj.id === element.itemId
        })
        element.displayname = AllFilterModel[_index].displayname || null;
        element.refReturn = AllFilterModel[_index].refReturn || null;
        element.enumArray = AllFilterModel[_index].enumArray || null;
        let predicateValue = undefined;
        if (element.ctrlType === 'predicatedatepicker') {
          element.value1 = { value1: element.value1, value2: element.value2, predicateValue: element.predicateValue }
          predicateValue = element.predicateValue;
        };
        const { itemName, compareLogic, itemId, ctrlType, value1, value2, displayname, multSelect, refReturn, cRefType, enumArray } = element;
        let itemType = element.ctrlType;
        const filterVMField = new cb.models.FilterModel({
          predicateValue,
          compareLogic,
          ctrlType: itemType,
          value1: value1,
          value2: value2,
          displayname,
          multSelect,
          refReturn,
          cRefType: cRefType,
          enumArray
        });
        this.viewModel.addProperty(itemName, filterVMField);
        const lowerCtrlType = ctrlType && ctrlType.trim().toLocaleLowerCase();
        if (lowerCtrlType === 'refer' || lowerCtrlType === 'treerefer' || lowerCtrlType === 'listrefer' || lowerCtrlType === 'tagrefer') {
          this.triggerReferBrowse(filterVMField.getFromModel());
          this.triggerReferBrowse(filterVMField.getToModel());
        }
      })
      let checkedValue = [],mustArry = [];
      for (let j = 0; j < queryCheckValue.length; j++) {
        let Id = queryCheckValue[j].itemId;
        let bIsNullValue = queryCheckValue[j].bIsNull != undefined ? queryCheckValue[j].bIsNull : true
        let mustObj = { ID: (queryCheckValue[j].id || queryCheckValue[j].itemId), bIsNull: bIsNullValue }
        mustArry.push(mustObj)
        checkedValue.push(Id);
      }
      let checkedValue2 = [].concat(checkedValue)
      let copy_queryCheckValue = [].concat(queryCheckValue)
      this.setState({ queryCheckValue: copy_queryCheckValue, ValueList: queryCheckValue, InputValue: InputValue, id: ID, checkedValue, checkedValue2, inMouseitemName: "", IsdefaultValue: IsdefaultValue,planValue:isPublic,mustArry });
    }, this.state.modelId);
  }
  //删除
  deleteScheme(id, filtersId) {
    let self = this;
    this.props.filterredux.deleteScheme(id, filtersId, this.props.schemeListChange, this.state.modelId);
    let currentId = this.props.filterscheme[this.state.modelId].currentId;
    let schemeList = this.props.filterscheme[this.state.modelId].schemeList;
    if (currentId == id) {
      schemeList.forEach(function (ele, index) {
        if (ele.isDefault == 1) {
          self.props.filterredux.chooseScheme(ele.id, self.state.modelId);
          self.props.schemeChange(ele.id)
        }
      })
    }
  }
  //选择
  chooseScheme(id) {
    this.props.filterredux.chooseScheme(id, this.state.modelId);
    this.props.schemeChange(id)
    this.setState({ visible: !this.state.visible })
  }
  AddqueryItems() {
    return (<div className="query-button">
      <div className="query-item-button add-query-criteria" onClick={(e) => this.openQuerylist(e)}><SvgIcon type="plus" />添加查询条件</div>
      <Button type={"default"} className="cancelScheme" onClick={() => this.CloseAddScheme()}>取消</Button>
      <Button type={"primary"} className="confirmScheme" onClick={() => this.SaveSolution()}>确认</Button>
    </div>
    )
  }
  //保存查询方案
  SaveSolution() {
    let {solutionId} = this.state;
    let currentId = this.props.filterscheme[this.state.modelId].currentId;
    let Data = this.viewModel.collectData(true);
    let planValue = (this.state.User.indexOf("userdef_schemaSetting") > -1 || this.state.userType == 0)?this.state.planValue : 0
    let dateEmunMap = this.state.dateEmunMap;
    for (var key in Data) {
      if (dateEmunMap[key]) {
        for (var key1 in dateEmunMap[key]) {
          Data[key][key1] = dateEmunMap[key][key1];
        }
      }
    }
    let DataValue = {},isCheck = 0;
    let rangeInput;
    this.setState({ visible: false })
    if (this.props.filterscheme[this.state.modelId].isdefault) { isCheck = 1; }
    let commonList = [];
    for (let i = 0; i < this.commonVOs.length; i++) {
      let name = this.commonVOs[i].itemName;
      if (name in Data) {
        DataValue = Data[name];
        let dataLength = Object.keys(DataValue);
        if (dataLength.length > 1) { rangeInput = 1; }
        else { rangeInput = 0 }
        if ((DataValue.value1 instanceof Array) || (DataValue.value2 instanceof Array)) {
          (DataValue.value1 = DataValue.value1.join(",")) || (DataValue.value2 = DataValue.value2.join(","))
        }
        let itemId = this.commonVOs[i].itemId;
        let orderId = this.commonVOs[i].orderId;
        let id = this.commonVOs[i].id;
        let compareLogic = this.commonVOs[i].compareLogic;
        let bAutoflt = this.commonVOs[i].bAutoflt ? this.commonVOs[i].bAutoflt :false;
        let bIsNull = this.commonVOs[i].bIsNull ? this.commonVOs[i].bIsNull : false;
        this.commonNewitem = {
          "itemId": itemId,
          "orderId": orderId,
          "id": id,
          "compareLogic": compareLogic,
          "rangeInput": rangeInput,
          "bAutoflt": bAutoflt,
          "bIsNull":bIsNull
        }
        Object.assign(this.commonNewitem, DataValue);
      }
      commonList.push(this.commonNewitem)
      let hash = {};
      commonList = commonList.reduce(function (item, next) {
        hash[next.itemId] ? '' : hash[next.itemId] = true && item.push(next);
        return item
      }, [])
    }
    Solutionitem = {
      "solutionName": this.state.InputValue,
      "isDefault": isCheck,
      "filtersId": this.state.filterId,
      "id": this.state.id,
      "isPublic":planValue,
      "commonVOs": commonList,
    }
    let filtersId = this.state.filterId;
    if (this.state.InputValue) {
      if(solutionId === currentId){
        // this.props.filterredux.chooseScheme(currentId, this.state.modelId);
        // this.props.schemeChange(currentId)
        this.props.filterredux.ToSolution(Solutionitem, filtersId, this.props.schemeListChange, this.state.modelId,this.props.schemeChange,solutionId,);
      }
      else{this.props.filterredux.ToSolution(Solutionitem, filtersId, this.props.schemeListChange, this.state.modelId,null,null);}

      // solutionId == currentId ? this.props.schemeChange(solutionId) : null
      this.setState({ ValueList: [], checkedValue2: [], checkedValue: [], saveSort: [], enterArry: [],planValue:1 })
    }
    else { this.setState({ mention: true, saveSort: [], enterArry: [],mustArry:[] }) }
  }
  openQuerylist = (e) => {
    document.body.addEventListener('click', this.handleBodyClick);
    if (this.props.filterscheme[this.state.modelId].queryVisible == false) {
      this.props.filterredux.openQuerylist(!this.props.filterscheme[this.state.modelId].queryVisible, this.state.modelId);
    }
  }
  //取消添加查询条件
  QueryItem() {
    this.props.filterredux.openQuerylist(false, this.state.modelId);
    let _checkedValue = [], query_checkedValue = [];
    let { checkedValue, checkedValue2, ValueList, queryCheckValue } = this.state;
    ValueList.forEach((ele, index) => {
      query_checkedValue.push((ele.id || ele.itemId))
      queryCheckValue.forEach((element, index) => {
        if (element.itemId == (ele.id || ele.itemId)) {
          _checkedValue.push(queryCheckValue[index])
        }
        if (query_checkedValue.includes(element.itemId)) {
          query_checkedValue.splice(query_checkedValue.indexOf(element.itemId), 1)
        }
      })
    })
    let copy_checkedValue = [];
    if (_checkedValue != []) {
      _checkedValue.forEach((ele, index) => { copy_checkedValue.push(ele.itemId); })
    }
    else { copy_checkedValue = [].concat(_checkedValue); }
    checkedValue2 = [].concat(copy_checkedValue).concat(query_checkedValue)
    // commonVOs.splice(0, commonVOs.length)
    this.setState({ checkedValue2, visible: false });
  }
  QueryItemRender() {
    let queryList = this.props.filterscheme[this.state.modelId].queryList;
    let a = this.props.filterscheme[this.state.modelId].queryVisible
    let noData = 'filter_scheme_popoverdown';
    if (!queryList) return
    if (queryList.length > 0) {
      noData = 'filter_scheme_popover'
    }
    let queryContent =
      <Popover
        overlayClassName={noData}
        content={this.getQueryContent()}
        trigger={"click"}
        visible={this.props.filterscheme[this.state.modelId].queryVisible}
        onVisibleChange={() => this.visibleChange()}
        placement="topLeft"
      >
      </Popover>;
    return <div className="ant-popover-left">{queryContent}</div>;
  }
  visibleChange = () => {
    this.props.filterredux.openQuerylist(false, this.state.modelId);
  }
  //添加查询条件Popover的content
  getQueryContent() {
    let ContentCheckBoxs = [];
    let queryList = this.props.filterscheme[this.state.modelId].queryList;
    let { checkedValue, checkedValue2 } = this.state;
    queryList.forEach(function (ele, index) {
      let id = ele.id.toString();
      let itemTitle = ele.itemTitle;
      let checkedgroup;
      checkedgroup = (<div><Checkbox key={index} onChange={this.onChangeCheck.bind(this)} value={id} checked={checkedValue.includes(Number(id)) || checkedValue2.includes(Number(id))}>{itemTitle}</Checkbox></div>)
      ContentCheckBoxs.push(checkedgroup)
    }, this)
    return <div className='query-criteria-select' style={{ paddingLeft: "10px" }}>
      <div className="ant-checkbox-group">
        {ContentCheckBoxs}
      </div>
      <div className='Checked-confirm-btn'>
        <Button type={"primary"} size="small" className="confirmChecked" onClick={() => this.AddDataOk()}>确认</Button>
        <Button type={"default"} size="small" className="cancelChecked" onClick={() => this.QueryItem()}>取消</Button>
      </div>
    </div>
  }
  //勾选查询条件
  onChangeCheck(e) {
    let { checkedValue, checkedValue2 } = this.state;
    let _num = Number(e.target.value);
    if (checkedValue2.includes(_num)) { checkedValue2.splice(checkedValue2.indexOf(_num), 1); }
    else { checkedValue2.push(_num); }
    if (checkedValue.includes(_num)) { checkedValue.splice(checkedValue.indexOf(_num), 1); }
    this.setState({ checkedValue2, checkedValue })
  }
  //添加查询条件确认
  AddDataOk = () => {
    this.props.filterredux.openQuerylist(false, this.state.modelId);
    let ValueList = [];
    let queryList = this.props.filterscheme[this.state.modelId].queryList
    let { checkedValue, checkedValue2, queryCheckValue, saveSort } = this.state;
    checkedValue = [].concat(checkedValue2)
    ValueList = checkedValue.map(value => {
      let _queryList = queryList.find(v => v.id === value);
      return _queryList || [];
    })
    //编辑时
    ValueList = ValueList.map(value => {
      let _queryCheckValue = queryCheckValue.find(v => v.itemId === value.id);
      return _queryCheckValue || value;
    })
    if (saveSort && saveSort.length > 0) {
      let copyList = _.cloneDeep(ValueList)
      saveSort.forEach((element) => {
        let _index = _.findIndex(copyList, (obj) => {
          return (obj.id || obj.itemId) === (element.id || element.itemId);
        })
        if (_index > -1) {
          copyList.splice(_index, 1)
        }
      })
      saveSort = saveSort.concat(copyList)
      ValueList = saveSort.map(value => {
        let thisObj = ValueList.find(v => (v.itemId || v.id) === (value.ID || value.id || value.itemId));
        // thisObj.bAutoflt = value.bAutoflt;
        return thisObj || value
      })
    }
    ValueList.forEach((element) => {
      const { itemName, compareLogic, itemType, ctrlType, cRefType, value1, defaultVal1, defaultVal2, value2, displayname, multSelect, refReturn, referCode, enumArray } = element;
      const filterVMField = new cb.models.FilterModel({
        compareLogic,
        ctrlType: itemType || ctrlType,
        value1: value1 || defaultVal1,
        value2: value2 || defaultVal2,
        displayname,
        multSelect,
        refReturn,
        cRefType: referCode || cRefType,
        enumArray
      });
      this.viewModel.addProperty(itemName, filterVMField);
      let eleType = itemType || ctrlType
      const lowerCtrlType = itemType || ctrlType && eleType.trim().toLocaleLowerCase();
      if (lowerCtrlType === 'refer' || lowerCtrlType === 'treerefer' || lowerCtrlType === 'listrefer' || lowerCtrlType === 'tagrefer') {
        this.triggerReferBrowse(filterVMField.getFromModel());
        this.triggerReferBrowse(filterVMField.getToModel());
      }
    })
    this.setState({ ValueList, checkedValue, saveSort: [] });
  }
  getComponent(ComName, model, config, ctrlType, item, type) {
    const { cShowCaption, enumArray, multSelect, itemName } = item;
    if (ComName == "tagbutton") {
      ComName = BasicComponents.Tag2;
      return <ComName model={model} TagData={enumArray} TagCanMultSel={multSelect} {...config} ></ComName>;
    }
    if (ctrlType == 'datepicker' && this.enumArr && this.enumArr.length > 0) {
      let buttons = [], enumValue = null, val = null;
      let checkedKey = null, dateEmunMap = this.state.dateEmunMap;
      if (type == 'from') {
        val = item.value1;
        if (dateEmunMap && dateEmunMap[itemName]) checkedKey = dateEmunMap[itemName].value1;
      } else {
        val = item.value2;
        if (dateEmunMap && dateEmunMap[itemName]) checkedKey = dateEmunMap[itemName].value2;
      }
      if (!checkedKey) checkedKey = val;
      this.enumArr.forEach(ele => {
        buttons.push(
          <span className={ele.key == checkedKey ? 'checked' : ''} onClick={e => this.onDateEmunClick(ele.key, item, type, model)}>{ele.value}</span>
        )
      });
      config.footerDom = (
        <div className="yxy_datepicker_footer">{buttons}</div>
      )
      if (this.state.dateEmunMap[item.itemName])
        enumValue = this.state.dateEmunMap[item.itemName][type == 'from' ? 'value1' : 'value2'];
      config.enumArr = this.enumArr;
      config.enumValue = enumValue;
      config.onChange = value => this.onDateChange(value, item, type);
      return <BasicComponentsMap.datepicker_design model={model} title={cShowCaption} {...config} />
    }
    return ComName ? <ComName model={model} title={cShowCaption} isInFilterJSX={true} {...config} /> : <h1>{ctrlType}</h1>;
  }
  onDateEmunClick = (key, item, type, model) => {
    let { dateEmunMap } = this.state;
    if (!dateEmunMap[item.itemName]) dateEmunMap[item.itemName] = {};
    if (type == 'from')
      dateEmunMap[item.itemName].value1 = key;
    else
      dateEmunMap[item.itemName].value2 = key;
    model.setValue(key);
    model.setState('open', false);
    this.setState({ dateEmunMap });
  }
  onDateChange = (value, item, type) => {
    let { dateEmunMap } = this.state;
    if (!dateEmunMap[item.itemName]) return;
    if (type == 'from')
      dateEmunMap[item.itemName].value1 = null;
    else
      dateEmunMap[item.itemName].value2 = null;
    this.setState({ dateEmunMap });
  }
  onMouseIsenter(Isenter, itemName) {
    if (Isenter) { this.setState({ inMouseitemName: itemName }); }
    else { this.setState({ inMouseitemName: "" }); }
  }
  enterClick(e, element) {
    let enterTag = e.target.checked
    let { enterArry } = this.state;
    let enterObj = { ID: (element.id || element.itemId), bAutoflt: enterTag }
    let _index = _.findIndex(enterArry, (obj) => {
      return (obj.ID) === (element.id || element.itemId);
    })
    if (_index > -1) {
      enterArry.splice(_index, 1)
    }
    enterArry.push(enterObj)
    this.setState({ enterArry })
  }
  mustInput(e,element){
    let mustTag = e.target.checked;
    let { mustArry } = this.state;
    let mustObj = { ID: (element.id || element.itemId), bIsNull: !mustTag }
    let _index = _.findIndex(mustArry, (obj) => {
      return (obj.ID) === (element.id || element.itemId);
    })
    if (_index > -1) {
      mustArry.splice(_index, 1)
    }
    mustArry.push(mustObj)
    this.setState({ mustArry })
  }
  AddData() {
    let { ValueList, startEnter, enterArry,mustArry} = this.state;
    let controlRender = [];
    this.commonVOs = [];
    ValueList.forEach(function (element, index) {
      let enterIndex = _.findIndex(enterArry, (obj) => {
        return (obj.ID) === (element.id || element.itemId);
      })
      let mustIndex = _.findIndex(mustArry,(obj)=>{
        return (obj.ID) == (element.id || element.itemId)
      })
      if (enterIndex > -1) {
        element.bAutoflt = enterArry[enterIndex].bAutoflt
      }
      if(mustIndex > -1){
        element.bIsNull = mustArry[mustIndex].bIsNull
      }
      else{
        element.bIsNull = true
      }
      const ele = element;
      let { itemName, itemTitle, compareLogic, enumArray, multSelect } = ele;
      let mustCheck = false;
      let itemType = ele.itemType || ele.ctrlType;
      let uniqueId = index + (ele.id || ele.itemId)
      const filterVMField = this.viewModel.get(itemName);
      let fromModel = filterVMField.getFromDisplayModel() || filterVMField.getFromModel();
      let toModel = filterVMField.getToModel();
      let ctrlType;
      if (itemType) { ctrlType = itemType.trim().toLocaleLowerCase(); }
      else { ctrlType = "input"; }
      const options = [];
      const Option = Select.Option;
      let compareLogicData = Object.assign({}, this.props.filterscheme[this.state.modelId].compareLogicList);
      if (multSelect && (ctrlType === 'refer' || ctrlType === 'treerefer' || ctrlType === 'listrefer' || ctrlType === 'tagrefer')) {
        compareLogicData = { in: compareLogicData.in, nin: compareLogicData.nin };
      }
      if (ctrlType === 'tagbutton') {
        delete compareLogicData.between
      }
      if (ctrlType == "predicatedatepicker") {
        let keyvalue = "between"
        let compareLogicItem = (<Option key={keyvalue} style={{ width: 60 }} >{compareLogicData[keyvalue]}</Option>)
        options.push(compareLogicItem)
      }
      else {
        for (var keyvalue in compareLogicData) {
          let compareLogicItem = (<Option key={keyvalue} style={{ width: 60 }} >{compareLogicData[keyvalue]}</Option>)
          options.push(compareLogicItem)
        }
      }
      let config = {};
      let ComName = "";
      if (ctrlType == "tagbutton") { ComName = "tagbutton" }
      else { ComName = BasicComponentsMap[ctrlType]; }
      let control;
      this.commonitem = {
        "itemId": ele.id || ele.itemId,
        "orderId": index,
        "itemName": ele.itemName,
        "id": id,
        "compareLogic": compareLogic,
        "bAutoflt": ele.bAutoflt,
        "bIsNull":ele.bIsNull
      };
      if (this.commonVOs.length > 0) {
        let _index = _.findIndex(this.commonVOs, (obj) => {
          return obj.itemName === ele.itemName && obj.itemId === (ele.id || ele.itemId);
        })
        if (_index < 0) this.commonVOs.push(this.commonitem);
      }
      else { this.commonVOs.push(this.commonitem); }
      let bshowupdown = (ele.itemName == this.state.inMouseitemName ? true : false);
      if(ele.bIsNull != undefined){
        mustCheck = ele.bIsNull ? false : true
      }
      let updown = <span className="sumarea_list_updown">
        {/* <Button style={{ borderWidth: 0 }} className="action-shanchucopy2" onClick={() => this.sortClick('up', index, element)}><Icon type={'shanchucopy2'}></Icon></Button>
      <Button style={{ borderWidth: 0 }} className="action-shanchucopy1" onClick={() => this.sortClick('down', index, element)}><Icon type={'shanchucopy1'}></Icon></Button> */}
        <Checkbox checked={mustCheck} onChange={(e)=>this.mustInput(e,element)} className="must_input">必输</Checkbox>
        <Checkbox checked={ele.bAutoflt} onChange={(e) => this.enterClick(e, element)} className="enter_search">回车搜索</Checkbox>
        <span style={{ borderWidth: 0 }} className="action-guanbi1" onClick={() => this.sortClick('delete', index, element)}><Icon type={'self-jian'}></Icon></span>
        {/* {huiche} */}
      </span>
      if (compareLogic === 'between') {
        if (ctrlType == "predicatedatepicker") {
          control = (
            <Row  data-id={ele.id || ele.itemId}>
              <div className="Test-time-two sumarea_list_item"
                // onMouseEnter={(e) => this.onMouseIsenter(true, ele.itemName, index)}
                // onMouseLeave={(e) => this.onMouseIsenter(false, ele.itemName, index)}
                >
                <Col className="query-content-title"><span>{itemTitle}</span></Col>
                <Col><Select className="compareLogic" value={compareLogicData[compareLogic]} onChange={(value) => this.handleChange(value, ele.id || ele.itemId, ctrlType)}>{options}</Select> </Col>
                <Col className="query-picker query-copypicker">{this.getComponent(ComName, fromModel, config, ctrlType, ele, 'from')}</Col>
                {/* {mustInput}
                {huiche} */}
                {updown}
              </div>
            </Row>
          );
        }
        else {
          control = (
            <Row data-id={ele.id || ele.itemId} >
              <div className="Test-time-two sumarea_list_item"
                // onMouseEnter={(e) => this.onMouseIsenter(true, ele.itemName, index)}
                // onMouseLeave={(e) => this.onMouseIsenter(false, ele.itemName, index)}
                >
                <Col className="query-content-title"><span>{itemTitle}</span></Col>
                <Col><Select className="compareLogic" value={compareLogicData[compareLogic]} onChange={(value) => this.handleChange(value, ele.id || ele.itemId, ctrlType)}>{options}</Select> </Col>
                <Col className="query-component-1">{this.getComponent(ComName, fromModel, config, ctrlType, ele, 'from')}</Col>
                <Col className="query-component-2"><span>至</span></Col>
                <Col className="query-component-3">{this.getComponent(ComName, toModel, config, ctrlType, ele, 'to')}</Col>
                {/* {mustInput}
                {huiche} */}
                {updown}
              </div>
            </Row>
          );
        }
      }
      else {
        control = (
          <Row  data-id={ele.id || ele.itemId}>
            <div className="query-content-list sumarea_list_item"
              // onMouseEnter={(e) => this.onMouseIsenter(true, ele.itemName)}
              // onMouseLeave={(e) => this.onMouseIsenter(false, ele.itemName)}
              >
              <Col className="query-content-title"><span>{itemTitle}</span></Col>
              <Col><Select className="compareLogic" value={compareLogicData[compareLogic]} style={{ width: 60 }} onChange={(value) => this.handleChange(value, ele.id || ele.itemId, ctrlType)}>{options}</Select></Col>
              <Col className="query-component-3">{this.getComponent(ComName, fromModel, config, ctrlType, ele, 'from')}</Col>
              {/* {mustInput}
              {huiche} */}
              {updown}
            </div>
          </Row>
        );
      }
      controlRender.push(control)
    }, this)
    return <div className="query-content-ranking">
    <Sortable
            tag='div'
            options={{
              group: {
                name: 'shared',
                pull: false,
                put: false
              },
              animation: 150,
              ghostClass: 'blue-background-class',
              scroll: true,
              scrollSensitivity: 10,
              scrollSpeed: 30,
            }}
            onChange={(order) => {
              this.dragOrder(order)
            }}

          >
            {controlRender}
          </Sortable>
    </div>
  }
  dragOrder(evl){
    let {ValueList} = this.state;
    let copyList = [],copyCheck = [],copyCheck2=[];
    evl.forEach((val)=>{
      ValueList.forEach((ele)=>{
        if(val == (ele.id || ele.itemId)){
          let id = ele.id || ele.itemId
          copyList.push(ele)
          copyCheck.push(id)
          copyCheck2.push(id)
        }
      })

    })
    this.setState({ValueList:copyList,checkedValue:copyCheck,checkedValue2:copyCheck2})
  }
  // handleChange(value, id, ctrlType) {
  //   let { ValueList } = this.state;
  //   this.commonVOs.forEach(function (ele, index) {
  //     if (ele.itemId == id) {
  //       if (ele.compareLogic != value) {
  //         ele.compareLogic = value;
  //       }
  //     }
  //   })
  //   let _index = _.findIndex(ValueList, function (obj) { return obj.id == id || obj.itemId == id; })
  //   if (_index > -1) {
  //     ValueList[_index].compareLogic = value;
  //   }
  //   this.setState({ ValueList })
  // }
  //当选择为between时
  handleChange(value, id, ctrlType) {
    let { ValueList } = this.state;
    this.commonVOs.forEach(function (ele, index) {
      if (ele.itemId == id) {
        if (ele.compareLogic != value) {
          ele.compareLogic = value;
        }
      }
    })
    let _index = _.findIndex(ValueList, function (obj) { return obj.id == id || obj.itemId == id; })
    if (_index > -1) {
      ValueList[_index].compareLogic = value;
      if (value == 'between') {
        let model = this.viewModel.get(ValueList[_index].itemName);
        let toModel = model.getToModel();
        if (!toModel) {
          toModel = new cb.models.SimpleModel();
          model._set_data('toModel', toModel, true);
          model._set_data('between', true, true);
        }
      }

    }
    this.setState({ ValueList })
  }
  //排序
  sortClick(type, index, element) {
    let { ValueList, checkedValue, checkedValue2, queryCheckValue, saveSort, enterArry } = this.state;
    let ValueListSort = [].concat(ValueList);
    saveSort = [];
    if (type == "up" && index == 0) return;
    if (type == "down" && index == ValueListSort.length - 1) return;
    let pre = cb.utils.extend(true, {}, ValueListSort[index - 1]);
    let next = cb.utils.extend(true, {}, ValueListSort[index + 1]);
    let now = cb.utils.extend(true, {}, ValueListSort[index]);
    let commonvosPre = cb.utils.extend(true, {}, this.commonVOs[index - 1]);
    let commonvosNext = cb.utils.extend(true, {}, this.commonVOs[index + 1]);
    let commonvosNow = cb.utils.extend(true, {}, this.commonVOs[index]);
    if (type == 'up') {
      ValueListSort[index] = pre;
      ValueListSort[index - 1] = now;
      this.commonVOs[index] = commonvosPre;
      this.commonVOs[index - 1] = commonvosNow;
    }
    if (type == 'down') {
      ValueListSort[index] = next;
      ValueListSort[index + 1] = now;
      this.commonVOs[index] = commonvosNext;
      this.commonVOs[index + 1] = commonvosNow
    }
    if (type == 'delete') {
      let ID = ValueListSort[index].id || ValueListSort[index].itemId
      ValueListSort.splice(index, 1)
      if (checkedValue2.includes(ID)) { checkedValue2.splice(checkedValue2.indexOf(ID), 1); }
      queryCheckValue.forEach((ele, index) => {
        if (ID == ele.itemId) {
          queryCheckValue.splice(index, 1)
        }
      })
      this.commonVOs.forEach((element, index) => {
        if (ID == element.itemId) {
          this.commonVOs.splice(index, 1)
        }
      })
      checkedValue = [].concat(checkedValue2)
      let _index = _.findIndex(enterArry, (obj) => {
        return obj.ID === ID
      })
      if (_index > -1) {
        enterArry.splice(_index, 1)
      }
    }
    this.commonVOs.forEach((ele, index) => {
      ele.orderId = index
    })
    this.setState({ ValueList: ValueListSort, checkedValue2, checkedValue, queryCheckValue, saveSort: ValueListSort, enterArry })
  }
  AddScheme() {
    let schemeList = this.props.filterscheme[this.state.modelId].schemeList;
    // this.props.filterredux.getQueryItem(this.state.modelId, this.state.filterId,schemeList);
    this.props.filterredux.AddScheme(!this.props.filterscheme[this.state.modelId].bAddscheme, this.state.modelId);
    if (this.props.filterscheme[this.state.modelId].bEdit) {
      this.props.filterredux.Isedit(!this.props.filterscheme[this.state.modelId].bEdit, this.state.modelId);
    }
    if (this.props.filterscheme[this.state.modelId].isdefault) {
      this.props.filterredux.IsDefault(!this.props.filterscheme[this.state.modelId].isdefault, this.state.modelId);
    }
    if (this.props.filterscheme[this.state.modelId].queryVisible) {
      this.props.filterredux.openQuerylist(false, this.state.modelId);
    }
    this.setState({ visible: false, ValueList: [], InputValue: "", checkedValue: [], queryCheckValue: [], inMouseitemName: "", checkedValue2: [], mention: false, id: null });
  }
  CloseAddScheme() {
    this.props.filterredux.AddScheme(false, this.state.modelId);
    this.setState({ visible: false, ValueList: [], saveSort: [], enterArry: [],mustArry:[] })
  }
  onChangeScheme(e){
    let planValue = e.target.value
    this.setState({planValue:planValue})
  }
  AddSchemeContent() {
    let { mention,User,userType,planValue,IsdefaultValue } = this.state;
    let schemeContent = this.AddData();
    let bEdit = this.props.filterscheme[this.state.modelId].bEdit;
    let nameMention = '';
    let input_schemename = "";
    let showPlan = User.indexOf("userdef_schemaSetting") > -1 || userType == 0 ? true :false;
    let isDefault = this.props.filterscheme[this.state.modelId].isdefault
    if (mention) {
      nameMention = (<span className="scheme-name-mention">不能为空</span>);
      input_schemename = "input_schemename"
    }
    if((User.indexOf("userdef_schemaSetting") < 0 ) && (userType != 0)){
      bEdit = true;
      planValue = 0
    }
    let disCheck = planValue && IsdefaultValue && bEdit ? true : false;
    let nameContent = (<div className="add-scheme">
      <div className={showPlan ? "show_pubper":"hide_pubper"}>
        <Radio.Group onChange={(e)=>this.onChangeScheme(e)} value={planValue}>
        <Radio disabled={bEdit? true:false} value={1}>公共方案</Radio>
        <Radio disabled={bEdit? true:false} value={0}>个人方案</Radio>
        </Radio.Group>
      </div>
      <span className="drag_sort">拖拽查询条件可以调整顺序</span>
      <Row className="add-scheme-content">
        <Col span={1} className="scheme-name"><i className="anticon anticon-star"></i>名称</Col>
        <Col span={4} className="scheme-name-content"><Input type="text" value={this.state.InputValue} onChange={this.InputValue.bind(this)} className={input_schemename} /> </Col>
        <Col span={5} className="scheme-set"><Checkbox checked={isDefault} disabled={disCheck} onClick={() => this.IsDefault()}>设为默认</Checkbox></Col>
      </Row>
      {nameMention}
      <div className="sort_drop">{schemeContent}</div>
    </div>)
    return nameContent
  }
  IsDefault() {
    let { IsdefaultValue,planValue } = this.state;
    if (this.props.filterscheme[this.state.modelId].bEdit) {
      if(planValue){
        if (IsdefaultValue) {
          this.props.filterredux.IsDefault(this.props.filterscheme[this.state.modelId].isdefault, this.state.modelId);
        }
        else { this.props.filterredux.IsDefault(!this.props.filterscheme[this.state.modelId].isdefault, this.state.modelId); }
      }
      else{
        this.props.filterredux.IsDefault(!this.props.filterscheme[this.state.modelId].isdefault, this.state.modelId);
      }
    }
    else { this.props.filterredux.IsDefault(!this.props.filterscheme[this.state.modelId].isdefault, this.state.modelId); }
  }
  InputValue(e) {
    let solutionName = ""
    solutionName = e.target.value
    this.setState({ InputValue: solutionName })
  }
  handleCancel() {
    this.CloseAddScheme();
    this.setState({ visible: false, ValueList: [], enterArry: [],planValue:1 })
  }
  AddSchemeRender() {
    let bAddscheme = this.props.filterscheme[this.state.modelId].bAddscheme;
    let bEdit = this.props.filterscheme[this.state.modelId].bEdit;
    let addqueryItems = this.AddqueryItems();
    let queryItemRender = this.QueryItemRender()
    let addSchemeContent = this.AddSchemeContent()
    let { definedVisible } = this.state;
    let content;
    content = <div><Modal className="scheme-content" title={bEdit ? "编辑" : "新增"} visible={true} onOk={(e) => this.handleok(e)}
      onCancel={(e) => this.handleCancel(e)} maskClosable={false} style={{ height: 400 }} footer={null}>
      <div className="Scheme-Content-body">{addSchemeContent}</div>
      <div className="query-state"> {queryItemRender}</div>
      <div className="ant-modal-footer">{addqueryItems}</div>
    </Modal>
    </div>;
    if (bAddscheme) { return content; }
    else {
      if (definedVisible) {
        return (<FilterDefined visible={this.state.definedVisible} filterId={this.state.filterId} model={this.props.model} modelId={this.state.modelId} regetquery={this.props.filterredux.getQueryItem}></FilterDefined>);
      }
      else return content = "";
    }
  }
}
function mapStateToProps(state) {
  return { filterscheme: state.filterscheme.toJS() }
}
function mapDispatchToProps(dispatch) {
  return { filterredux: bindActionCreators(filterredux, dispatch), }
}
export default connect(mapStateToProps, mapDispatchToProps)(FilterScheme);



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/filter/FilterScheme.jsx